import { Modify } from "@assets"
import { LabelIconError, PreferredZoneModal } from "@atomic"
import { Title14, Title18 } from "@stylesheets"
import React, { useEffect, useState } from "react"
import { View, TouchableOpacity, Text } from "react-native"
import { I18n } from "react-redux-i18n"
import { useSelector } from "react-redux"
import { GlobalState } from "@redux"
import { prefZoneStyles } from "./style"

type PreferredZoneData = {
  selectedPrefZones: any[]
  hasPrefZonesError: boolean
}

type PreferredZoneFieldProps = {
  zoneData: PreferredZoneData
  setZoneData: (
    data: PreferredZoneData | ((prev: PreferredZoneData) => PreferredZoneData)
  ) => void
}

export const PreferredZoneField = ({
  zoneData,
  setZoneData,
}: PreferredZoneFieldProps) => {
  const { selectedPrefZones, hasPrefZonesError } = zoneData

  const [maximumPreferredZones, setMaximumPreferredZones] = useState(0)
  const [showPreferredZonesModal, setshowPreferredZonesModal] = useState(false)
  const [holdingZones, setHoldingZones] = useState<any[]>([])

  const selectedHolding = useSelector(
    (state: GlobalState) => state.account.selectedHolding
  )

  useEffect(() => {
    setZoneData((prev) => ({
      ...prev,
      selectedPrefZones: selectedHolding?.preferredZones ?? [],
    }))
    setHoldingZones(selectedHolding?.zones ?? [])
    setMaximumPreferredZones(selectedHolding?.maximumPreferredZones ?? 0)
  }, [selectedHolding, setZoneData])

  const styles = prefZoneStyles(false)

  const handleClosePrefZones = (prefZones: any[]) => {
    setZoneData(() => ({
      selectedPrefZones: prefZones.map((zone) => ({
        id: String(zone.id),
        name: zone.name,
      })),
      hasPrefZonesError: !(
        prefZones.length > 0 && prefZones.length <= maximumPreferredZones
      ),
    }))
    setshowPreferredZonesModal(false)
  }

  return (
    <View style={styles.container}>
      <Title18 isBold style={styles.titleText}>
        {selectedPrefZones.length === 1
          ? I18n.t("preferredZones.title")
          : I18n.t("preferredZones.titlePlural")}
        {" *"}
      </Title18>
      <View
        style={[
          styles.cardsContainer,
          selectedPrefZones.length > 0 && { flexDirection: "row" },
        ]}
      >
        {selectedPrefZones.length > 0 ? (
          <>
            {selectedPrefZones.map(
              (
                eachPreferredZone: {
                  id: string
                  name: string
                },
                index: number
              ) => (
                <View
                  key={`Filter_OffeZonesAndTypes_1_${index}`}
                  style={styles.zonesCard}
                >
                  <Text
                    numberOfLines={1}
                    ellipsizeMode='tail'
                    style={styles.zonesCardText}
                  >
                    {eachPreferredZone.name}
                  </Text>
                </View>
              )
            )}
          </>
        ) : (
          <Title14>{I18n.t("preferredZones.noZonesProfile")}</Title14>
        )}
        <TouchableOpacity
          style={styles.modifyIconContainer}
          onPress={() => {
            setshowPreferredZonesModal(true)
          }}
        >
          <Modify height={40} />
        </TouchableOpacity>
      </View>
      {hasPrefZonesError && (
        <View style={styles.errorContainer}>
          <LabelIconError
            title={I18n.t("preferredZones.errorZones")}
            textStyle={styles.labelTextIconError}
            style={styles.labelIconError}
          />
        </View>
      )}

      <PreferredZoneModal
        idHoldingView={selectedHolding?.id}
        preferredZones={selectedPrefZones}
        zones={holdingZones}
        maximumPreferredZones={maximumPreferredZones}
        onClose={handleClosePrefZones}
        isOpen={showPreferredZonesModal}
        closeModal={() => setshowPreferredZonesModal(false)}
      />
    </View>
  )
}
